import React from 'react';
import { Translate } from '@bynder/localization';
import { Table } from '@bynder/design-system';
import CategoryTitleCell from 'packages/pages/components/list/cell/CategoryTitleCell';
import DateCell from 'packages/pages/components/list/cell/DateCell';
import OwnerNameCell from 'packages/pages/components/list/cell/OwnerNameCell';
import CategoryContextMenu from 'packages/pages/components/categories/CategoryContextualMenu';
import { SortingFilterType } from 'packages/pages/components/filters/components/Ordering/types';
import { Collection } from 'packages/store/collections/types';
import { CategoryListItemProps, RenderCategoryItemsProps } from './types';

export const headers = [
    { id: 'name', title: <Translate id="listview.template.column.name" /> },
    { id: 'date_created', title: <Translate id="listview.template.column.date_created" /> },
    { id: 'date_updated', title: <Translate id="listview.template.column.last_modified" /> },
    { id: 'ownership', title: <Translate id="listview.template.column.ownership" />, notSortable: true },
    { id: 'templates', title: <Translate id="listview.category.column.templates" />, notSortable: true },
    { id: 'menu', title: '', notSortable: true },
];

// One of the two date columns is always hidden depending on the active sort,
// so only 5 columns are rendered at a time.
export const columnWidths = ['40%', '20%', '20%', '20%', 'auto'];

const CategoryListViewItem = ({
    category,
    sort,
    menuActions,
    handleClick,
    allowedIndicatorTypes,
}: CategoryListItemProps) => {
    const [sortBy] = sort;
    const templatesCount = category.imageCreativesCount + category.videoCreativesCount;

    return (
        <Table.Row onClick={() => handleClick(category)}>
            <CategoryTitleCell category={category} allowedIndicatorTypes={allowedIndicatorTypes} />
            {sortBy !== SortingFilterType.LASTMODIFIED ? (
                <DateCell date={category.created} />
            ) : (
                <DateCell date={category.updated} />
            )}
            <OwnerNameCell item={category as unknown as Collection} />
            <Table.Cell textFlow="no-wrap">
                {templatesCount ? (
                    <Translate id="pages.categories.grid.numberOfTemplates" count={templatesCount} />
                ) : (
                    <Translate id="pages.categories.grid.numberOfTemplates.empty" />
                )}
            </Table.Cell>
            <Table.Cell textFlow="no-wrap">
                {menuActions && (
                    <Table.StopPropagation>
                        <CategoryContextMenu category={category} menuActions={menuActions} />
                    </Table.StopPropagation>
                )}
            </Table.Cell>
        </Table.Row>
    );
};

export const renderItems = ({
    categories,
    sort,
    menuActions,
    handleClick,
    allowedIndicatorTypes,
}: RenderCategoryItemsProps) =>
    categories.map((category) => (
        <CategoryListViewItem
            key={category.id}
            category={category}
            sort={sort}
            menuActions={menuActions}
            handleClick={handleClick}
            allowedIndicatorTypes={allowedIndicatorTypes}
        />
    ));
